
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('radialGradient',{attrs:{"id":"22-a","cx":"46.588%","cy":"65.195%","r":"100%","fx":"46.588%","fy":"65.195%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFD404"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#FFA204"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-width":"3","d":"M32 6.5c7.02 0 13.351.834 17.841 2.33 2.33.777 4.185 1.744 5.451 2.841C56.77 12.951 57.5 14.421 57.5 16c0 1.313-.505 2.543-1.513 3.653-.598.658-1.385 1.278-2.348 1.846A24.404 24.404 0 0156.5 33c0 6.765-2.742 12.89-7.176 17.324A24.423 24.423 0 0132 57.5a24.423 24.423 0 01-17.324-7.176A24.423 24.423 0 017.5 33a24.4 24.4 0 012.862-11.502c-.963-.567-1.751-1.187-2.349-1.845C7.005 18.543 6.5 17.313 6.5 16c0-1.578.73-3.049 2.208-4.329 1.266-1.097 3.12-2.064 5.45-2.84C18.649 7.334 24.98 6.5 32 6.5h0z"}}),_c('circle',{attrs:{"cx":"32","cy":"33","r":"23","fill":"url(#22-a)"}}),_c('path',{attrs:{"fill":"#353741","d":"M32 49c5.77 0 10.203-2.58 13.298-7.74a.5.5 0 00-.61-.724C40.458 42.179 36.23 43 32 43c-4.23 0-8.459-.821-12.688-2.464a.5.5 0 00-.61.723C21.797 46.42 26.229 49 32 49zm-7-17.048c3.75 0 5 4.762 5 2.381C30 31.953 28.75 26 25 26s-5 6.032-5 8.333c0 2.302 1.25-2.38 5-2.38zm14 0c3.75 0 5 4.762 5 2.381C44 31.953 42.75 26 39 26s-5 6.032-5 8.333c0 2.302 1.25-2.38 5-2.38z"}}),_c('path',{attrs:{"fill":"#0BAAF3","d":"M32 8c13.255 0 24 3 24 8s-10.745 8-24 8-24-3-24-8 10.745-8 24-8zm0 2c-7.855 0-18.667 1.875-18.667 5S24.145 19 32 19c7.855 0 18.667-.875 18.667-4S39.855 10 32 10z"}})])])
          )
        }
      }
    